/* eslint-disable no-unused-vars */

import { ObjectTransform } from '../shared/modules/search/list-search-types';
import { PaginatedResult } from '../shared/modules/search/search-types';

export interface BasicPartner {
  id: number;
  name: string;
  shortName: string;
  type: PartnerType;
  thumbnail: string | null;
  active: boolean;
  paymentDeadlineDays?: string;
}

export interface ExtendedPartner extends BasicPartner {
  paymentDeadlineDays: string;
  address: FullAddress;
}

export interface FullPartner extends ExtendedPartner {
  active: boolean;
  bankAccount: string;
  taxNumber: string;
  notes: string;
  cashSettledSupplier: boolean;
  newsletter: boolean;
  createdAt: string;
  updatedAt: string;
  primaryContactId: number;
  contacts: PartnerContact[];
  billingAddress: FullAddress;
  mailingAddress: FullAddress;
  isFavorite: boolean;
}

export interface SearchPartner extends ExtendedPartner {
  projects: {
    closed: number;
    active: number;
  };
}

export interface PartnerSearchResult extends PaginatedResult<SearchPartner> {
  favoritePartners: SearchPartner[] | [];
}

export interface PartnerContact {
  id: number;
  name: string;
  title: string;
  phone: string;
  email: string;
  notes: string;
  primary: boolean;
}

export interface CreateClient {
  name: string;
  shortName: string;
  type: PartnerType;
  taxNumber: string;
  address: CreateAddress;
  billingAddress: CreateAddress;
  paymentDeadlineDays: number;
  active: number;
}

export interface CreateSupplier extends CreateClient {
  bankAccount: string;
}

// prettier-ignore
export type CreatePartner<T extends PartnerType> =
  T extends PartnerType.CLIENT ? CreateClient :
    T extends PartnerType.SUPPLIER ? CreateSupplier :
      never;

export interface CreateContact {
  name: string;
  phone: string;
  email: string;
  title?: string;
  primary?: boolean;
  active?: boolean;
  notes?: string;
}

export type Partners = BasicPartner | ExtendedPartner | FullPartner | null;

export type PartnerKey<T extends Partners> = {
  [key in PartnerType]: T;
};

// prettier-ignore
export type PartnerTransform<T extends ObjectTransform> =
  T extends ObjectTransform.BASIC ? BasicPartner :
    T extends ObjectTransform.EXTENDED ? ExtendedPartner :
      never;

export interface FullAddress {
  id: number;
  street: string;
  country: string;
  postcode: string;
  city: string;
  county: string;
}

export interface CreateAddress {
  countryId: number;
  street: string;
  postcode: string;
  city: string;
}

export enum PartnerType {
  CLIENT = 'client',
  SUPPLIER = 'supplier',
  INTERNAL = 'internal',
}

export enum PartnerState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'all',
}
